const captchaAppId = process.env.CAPTCHA_APPID
export default {
    install(Vue) {
        let Captcha = new TencentCaptcha(captchaAppId, res => {
            new Vue().$bus.$emit('getTicket', res)
        }, {});
        Vue.prototype.$captcha = Captcha
    }
}


// WEBPACK FOOTER //
// ./src/plugins/captcha.js